import SiteText from "./SiteText";
import Styles from "./Styles";
import LogoSquare from "./assets/square-logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Description = () => {
    return <div className="flex max-lg:flex-col items-center my-10 lg:my-20 px-8 lg:px-48">
        <div className="md:w-1/3 bg-secondary/50 rounded-full">
            <img className="max-md:size-64" src={LogoSquare} alt="Elite Power Wash Logo"/>
        </div>
        <div className="lg:w-2/3 p-4 lg:p-24">
            <div className="text-3xl font-bold">
                {SiteText.Description.Title}
            </div>
            <div>
                <br />
                <p>{SiteText.Description.Paragraph[0]}</p>
                <br />
                <p>{SiteText.Description.Paragraph[1]}</p>
                <br />
                <p className="flex justify-start items-center">
                    {SiteText.Description.Socials.FollowMesseage}
                    <a
                        href={SiteText.Description.Socials.Links.Facebook}
                        className="mx-2 size-10 rounded-full flex items-center justify-center bg-facebookLogoColor"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <FontAwesomeIcon className="text-3xl text-white" icon="fa-brands fa-facebook-f" />
                    </a>
                    <a
                        href={SiteText.Description.Socials.Links.Instagram}
                        className={`mx-2 size-10 rounded-full flex items-center justify-center ${Styles.Global.InstagramLogoGradient}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <FontAwesomeIcon className="text-3xl text-white" icon="fa-brands fa-instagram" />
                    </a>
                </p>
            </div>
        </div>
    </div>
};

export default Description;